import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn } from "src/components/organisms/auth";
import { useAuth } from "../auth/AuthContext";
import { TokenHelper } from "../auth/tokenHelper";
import CopyRight from "src/components/atoms/copy-right/CopyRight";
import ButtonPro from "src/components/atoms/button-pro/button-pro";
import Logo from "src/components/molecules/logo/Logo";
import InputBox from "src/components/atoms/input-box/input-box";
import LoadingModal from "src/components/molecules/loading-modal/loading-modal";

const Login: React.FC = () => {
  const [businessEmail, setBusinessEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const tokenHelper = useRef<TokenHelper | null>(null);

  useEffect(() => {
    tokenHelper.current = new TokenHelper();
  }, []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    signIn(businessEmail, password, async (err, result) => {
      if (err) {
        setLoading(false);
        console.log(`Login error ${JSON.stringify(err)}`);
        if (err.code === "UserNotConfirmedException") {
          navigate("/verify", {
            state: { businessEmail, password },
          });
        }
        setError(err.message || JSON.stringify(err));
      } else {
        // console.log(`Login result ${JSON.stringify(result)}`);
        const tokenProps = await tokenHelper.current?.decodeToken(
          result.accessToken.jwtToken
        );
        login({
          id: result.idToken.payload.sub,
          givenName: result.idToken.payload.given_name,
          familyName: result.idToken.payload.family_name,
          username: businessEmail,
          phoneNumber: result.idToken.payload.phone_number,
          ex_user_id: result.accessToken.payload.ex_user_id,
          accessToken: result.accessToken.jwtToken,
          num: result.accessToken.payload.num,
          accountId: tokenProps?.accountId ?? "",
          email: tokenProps?.emailId ?? "",
        }); // Set the authentication state to true with user data
        setLoading(false);
        navigate("/"); // Navigate to the protected page
      }
    });
  };

  return (
    <div className="bg-slate-900 font-Poppins flex flex-col items-center justify-center h-screen">
      <div className="bg-gradient-to-tl from-slate-600 to-slate-800 rounded-lg shadow-lg p-12 h-screen w-screen md:h-auto md:w-auto md:border-2">
        <Logo></Logo>
        <div className="font-bold text-center my-6 uppercase">
          <span className="font-Poppins tracking-wider bg-gradient-to-bl from-purple-600 to-red-800 text-4xl md:text-6xl font-bold lg:text-4xl bg-clip-text text-transparent uppercase drop-shadow-2xl">
            Admin Portal
          </span>
        </div>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <InputBox
              value={businessEmail}
              onChange={(value) => {
                setBusinessEmail(value);
              }}
              label="Email"
              type={"email"}
              required
            ></InputBox>
          </div>
          <div>
            <InputBox
              value={password}
              onChange={(value) => {
                setPassword(value);
              }}
              label="Password"
              type={"password"}
              required
            ></InputBox>
          </div>
          {/* Uncomment this if you need the forgot password link */}
          {/* <div className="text-right">
        <a href="/forgot-password" className="text-blue-500 hover:underline">
          Forgot password?
        </a>
      </div> */}
          <ButtonPro label={"Sign In"} type="submit"></ButtonPro>
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </form>
        <p className="text-white text-center mt-6">
          <CopyRight></CopyRight>
        </p>
      </div>
      {loading && (
        <>
          <LoadingModal
            open={loading}
            message="Signing you in..."
          ></LoadingModal>
        </>
      )}
    </div>
  );
};

export default Login;
